import CommonApi from "Api/CommonApi"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col } from "reactstrap"

const Miniwidget = props => {
  const accessToken = localStorage.getItem("accessToken")
  // const [metadata, setMetaData] = useState({})

  // const getAllMetaData = () => {
  //   const config = {
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //   }

  //   CommonApi.getAllMetaData(config)
  //     .then(response => {
  //       console.log(response.data)
  //       setMetaData(response.data)
  //     })
  //     .catch(error => {
  //       console.log(error)
  //     })
  // }

  // useEffect(() => {
  //   getAllMetaData()
  // }, [accessToken])

  // const updatedReports = props.reports.map(report => ({
  //   ...report,
  //   total: metadata[report.title.toLowerCase()] || 0, // Use default 0 if not found
  // }))

  return (
    <React.Fragment>
      <Row>
        {props.reports.map((report, key) => (
          <Col xl={3} sm={6} key={key}>
            <Card className="mini-stat bg-primary">
              <CardBody className="card-body mini-stat-img d-flex align-items-center gap-3">
                <div className="mini-stat-icon ">
                  <i className={"ion" + report.iconClass}></i>
                </div>
                <div className="text-white">
                  <h6 className="text-uppercase  font-size-16 text-white">
                    {report.title}
                  </h6>
                  <h2 className="text-white">{report.total}</h2>
                  {/* <span className={"badge bg-" + report.badgecolor}> {report.average} </span> <span className="ms-2">From previous period</span> */}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  )
}

export default Miniwidget
